import axiosInstance from '../functions/axiosInstance';
import server_config from '../ServerConfiguration';

const fevir_node_server_address = server_config["fevir_node_server_address"];

const get30dayViewHistory = async (apiToken = null) => {
    if (!apiToken) {
        console.log("no apiToken");
        return null;
    }
    console.log("CALLING SERVER with get30dayViewHistory")
    return await axiosInstance({
        method: 'POST',
        url: fevir_node_server_address,
        timeout: 120000,
        data: {
            'functionid': 'get30dayViewHistory',
            'apiToken': apiToken
        },
    }).then((resp) => {
        //returningdata = { 'success': true, 'resourceList': resourceList }
        //resourceList is array of objects with id, title, resourcetype, status
        if (resp?.data) {
            if (resp.data.success && resp.data.resourceList) {
                return resp.data.resourceList;
            } else {
                console.log("FAILURE in response from get30dayViewHistory call");
                return [];
            }
        }
        console.log("NO RESPONSE from get30dayViewHistory call");
    }).catch((error) => { console.log(error); });
}

export default get30dayViewHistory;